import { Persona, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { formatDisplayName, generateInitials } from '../../Utils/personaUtils';

interface MenuPersonaProps {
    name?: string;
    photo?: string;
}

const useStyles = makeStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        // Add transition to ensure smooth animation with drawer
        ...shorthands.transition('all', '0.4s', 'ease-in-out'),
    },
    personaButton: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        // Add transition to ensure smooth animation with drawer
        ...shorthands.transition('all', '0.4s', 'ease-in-out'),
    },
});

// implements the user persona display without logout functionality (logout moved to Settings page)
const MenuPersona: FC<MenuPersonaProps> = (props) => {
    const { name, photo } = props;
    const classes = useStyles();
    
    const displayName = formatDisplayName(name);
    const initials = generateInitials(name);

    return (
        <div className={classes.root}>
            <div className={classes.personaButton}>
                <Persona
                    name={displayName}
                    size="large"
                    textAlignment="center"
                    avatar={{
                        image: photo ? { src: photo } : undefined,
                        initials: { 
                            children: initials,
                            style: {
                                color: '#FF6542',
                                fontWeight: 'bold'
                            }
                        },
                        style: {
                            border: '2px solid #FF6542',
                            backgroundColor: 'transparent'
                        }
                    }}
                    primaryText={{
                        style: {
                            fontSize: tokens.fontSizeBase300,
                            fontWeight: tokens.fontWeightMedium,
                            color: tokens.colorNeutralForeground1,
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default MenuPersona;
